var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAdvantageIcon4(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "none",
    height: 36,
    viewBox: "0 0 36 36",
    width: 36,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m18 24.8v-3h9v3zm4 11.2v-2.7h-4v-3h4v-2.7h3v8.4zm5-2.7v-3h9v3zm2-5.75v-8.45h3v2.7h4v3h-4v2.75zm6.75-12.55h-3.1c-.7667-3.4-2.5-6.25-5.2-8.55s-5.85-3.45-9.45-3.45c-4.1787 0-7.7233 1.45533-10.634 4.366-2.91067 2.9107-4.366 6.4553-4.366 10.634 0 2.7.64167 5.1583 1.925 7.375s2.975 3.9917 5.075 5.325v-5.7h3v11h-11v-3h6.05c-2.43333-1.6-4.38333-3.7167-5.85-6.35-1.466667-2.6333-2.2-5.5167-2.2-8.65 0-2.5.475-4.8417 1.425-7.025.95-2.18333 2.23333-4.08333 3.85-5.7s3.51667-2.9 5.7-3.85c2.1833-.95 4.525-1.425 7.025-1.425 4.4667 0 8.3583 1.43333 11.675 4.3s5.3417 6.4333 6.075 10.7z",
    fill: "#fcc241"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAdvantageIcon4);
export default __webpack_public_path__ + "static/media/advantage-icon-4.6c73b2b0c1985bed8c88ebfd53ed68f3.svg";
export { ForwardRef as ReactComponent };